module.exports = __webpack_public_path__ + "static/media/ma-6.ac98b524.svg";